<div id="links">
    <a href="mailto:mail@andre-gross.dev">
        <app-dynamic-svg [imgName]="'email'" [folder]="'landing-page'"></app-dynamic-svg>
    </a>
    <a href="https://www.linkedin.com/in/andre-gro%C3%9F-b61b43339/" target="_blank" rel="noopener noreferrer">
        <app-dynamic-svg [imgName]="'linkedin'" [folder]="'landing-page'"></app-dynamic-svg>
    </a>
    <a href="https://github.com/Andre-Gross/" target="_blank" rel="noopener noreferrer">
        <app-dynamic-svg [imgName]="'github'" [folder]="'landing-page'"></app-dynamic-svg>

    </a>
</div>